<template>
  <div>
    <loading :active.sync="isLoading"></loading>
    <router-view></router-view>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.min.css';
import { eventHub } from '@/utils/eventhub';

export default {
  data() {
    return {
      isLoading: false,
    };
  },
  components: {
    Loading,
  },
  methods: {
    showSpinner() {
      this.isLoading = true;
    },
    hideSpinner() {
      this.isLoading = false;
    },
    logout() {
      if (this.$store.getters.user.type === 'client') {
        this.$store.dispatch('logout');
        this.$router.push({ name: 'client-login' });
      } else if (this.$store.getters.user.type === 'vibbrante') {
        this.$store.dispatch('logout');
        this.$router.push({ name: 'vibbrant-login' });
      }
    },
  },
  created() {
    eventHub.$on('before-request', this.showSpinner);
    eventHub.$on('request-error', this.hideSpinner);
    eventHub.$on('after-response', this.hideSpinner);
    eventHub.$on('response-error', this.hideSpinner);
    eventHub.$on('unauthorized', this.logout);
  },
  beforeDestroy() {
    eventHub.$off('before-request', this.showSpinner);
    eventHub.$off('request-error', this.hideSpinner);
    eventHub.$off('after-response', this.hideSpinner);
    eventHub.$off('response-error', this.hideSpinner);
    eventHub.$off('unauthorized', this.logout);
  },
};
</script>



// WEBPACK FOOTER //
// src/parts/pages/base.vue